import { useEffect, useState } from "react";
import { watchWaiting } from "../api/client";

/** Shorter waits than this show nothing: a bar that flashes for every quick answer is noise. */
const AFTER_MS = 150;

/**
 * The moving line along the top of the page while something somebody pressed
 * is on its way (owner 2026-10-16: 「加载中是不是要有ui显示出来不然看起来像卡了 用户就会继续
 * 一直按」). One look for every page — 话术榜, 经营, 小爱, a chat — rather than each
 * saying it its own way or not at all. The pointer turns to the busy one too.
 * It is about the page on screen: a page left before its answer came does not
 * keep it running (client.ts watchWaiting). Where you looked meanwhile is the
 * page's own placeholder (PageSkel.tsx) and its turning menu item (App).
 *
 * Only that: a page already drawn being read again in the background runs
 * nothing (client.ts). It also used to run once on every change of page, as
 * the prototype's does, so every press looked like a load (owner 10/27:
 * 「总是看见上面loading的动态在跑看起来画面像还在加载」); the menu answers a press itself.
 */
export default function LoadBar() {
  const [waiting, setWaiting] = useState(false);
  useEffect(() => {
    let timer = 0;
    const stop = watchWaiting((w) => {
      window.clearTimeout(timer);
      if (w.reads > 0) timer = window.setTimeout(() => setWaiting(true), AFTER_MS);
      else setWaiting(false);
    });
    return () => {
      window.clearTimeout(timer);
      stop();
    };
  }, []);
  useEffect(() => {
    document.documentElement.classList.toggle("is-waiting", waiting);
  }, [waiting]);
  return <div className={`loadbar${waiting ? " on" : ""}`} role="progressbar" aria-label="读取中" aria-hidden={!waiting} />;
}
